import { createBaseExportSchema } from '@app/modules/social-export/components/validation/useBaseExportSchema';
import { useMemo } from 'react';
import { IntlFormatters, useIntl } from 'react-intl';
import { z } from 'zod';

const TWEET_MAX_LENGTH = 280;

/** Builds the Zod schema for the Twitter/X publish form. */
export function createTwitterPublishSchema(t: IntlFormatters['$t']) {
  return createBaseExportSchema(t).extend({
    content: z.string().trim().min(1).max(TWEET_MAX_LENGTH),
  });
}

export type TwitterPublishValues = z.infer<ReturnType<typeof createTwitterPublishSchema>>;

/** Zod schema for the Twitter/X publish form with translated validation messages. */
export function useTwitterPublishSchema() {
  const { $t } = useIntl();
  return useMemo(() => createTwitterPublishSchema($t), [$t]);
}
